import { getUnitName } from "../../utils/unitNames";
import "./ItemParUnitSelect.css";

export default function ItemParUnitSelect({ value, baseUnitId, units, onChange, label, languageId, t, disabled = false }) {
  const selected = String(value || baseUnitId || "");
  const valid = units.some((unit) => String(unit.id) === selected);
  return <select className="item-par-unit" value={valid ? selected : ""} aria-label={label}
    aria-invalid={!valid && Boolean(selected) ? true : undefined} disabled={disabled || !units.length}
    onChange={(event) => onChange(event.target.value)}>
    {!valid && <option value="" disabled>{t("Select unit")}</option>}
    {units.map((unit) => <option key={unit.id} value={unit.id}>{getUnitName(unit, languageId)}</option>)}
  </select>;
}
